


































































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import {
  AppData,
  INCOME_RANGE,
} from "@/models/app-data";
import CommonMixin, { County } from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { WorkflowService } from "@/service/workflow.service";
import { EligibilityService } from "@/service/eligibility.service";
import { AlternateHSQualifierContent } from "@/models/content/alternate-hs-qualifier";
import { QualifierRule, matchQualifiers } from "@/models/rules";

@Component({
  components: {
    FooterButton
  }
})

export default class AlternateHSQualifier extends Mixins(CommonMixin) {
  PercentDone = 80;
  workflowService = new WorkflowService();
  eligibilityService = new EligibilityService();
  content: AlternateHSQualifierContent = {} as AlternateHSQualifierContent;
  fosterChecked = false;
  homelessChecked = false;
  benefitsChecked = false;
  specialNeedsChecked = false;
  noneChecked = false;
  appData = {} as AppData;
  textDirection = 'ltr'
  checkTextAlign = 'has-text-left'
  includedZipCodes: Array<string>  = []
    
  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getAlternateHSQualifierContent();
      this.textDirection = contentService.TextDirection();
      if ( this.textDirection == 'rtl'){
        this.checkTextAlign = 'has-text-right'
      }
      // Import the workflow if one is provided
      await this.loadData();
      if (this.appData != null) {
        this.fosterChecked = this.appData.foster;
        this.benefitsChecked = this.appData.benefits;
        this.homelessChecked = this.appData.homeless;
        this.noneChecked = this.appData.hsQualifierNone;
        this.putWorkflowStep( this.appData.workflowId, "AlternateHSQualifier") 
      }
    } catch (error) {
      this.showError(error as any);
    }
  }

  async loadData(): Promise<void> {
    if (this.$route?.query?.workflowid != null) {
      const workflowId = this.$route.query.workflowid + "";
      const appData = await this.workflowToAppData(workflowId);
      this.saveAppData(appData);
      this.appData = appData;

      //If we don't have the 250 plus income, redirect
      if (appData.fpl !== INCOME_RANGE.FPL_LVL_3_PLUS) {
        //If we don't have the income, redirect to initial requirements
        if (appData.eligibleIncome == null) {
          this.$router.replace({ path: "InitialRequirements" });
        } else {
          this.$router.replace({ path: "IncomeRange" });
        }
      }
    } else {
      this.appData = this.getAppData();
    }
  }

  optionChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked === true) {
      this.noneChecked = false;
    }
  }

  noneChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked == true) {
      this.fosterChecked = false;
      this.homelessChecked = false;
      this.benefitsChecked = false;
    }
  }

  public oneOrMoreApplies(): boolean {
    return (
      this.fosterChecked === true ||
      this.homelessChecked === true ||
      this.benefitsChecked === true
    );
  }

  // Create a double indexed array of the qualifiers

  public handleNextPageEvent(): void {
    if (this.appData == null) {
      this.appData = {} as AppData;
    }
    this.appData.foster = this.fosterChecked;
    this.appData.benefits = this.benefitsChecked;
    this.appData.homeless = this.homelessChecked;
    this.appData.hsQualifierNone = this.noneChecked;

    const oneOrMoreApplies = this.oneOrMoreApplies();

    if (oneOrMoreApplies === true) {
      this.clearGSRPQualifiers(this.appData);
      this.clearGSRPQualifiersList2(this.appData);
      this.clearHSQualifierList2(this.appData)
      this.clearHSQualifierList3(this.appData)
    }

    this.saveAppData(this.appData);

    if (this.allChildrenUnder4(this.appData)) {
      this.handleAllUnderFour();
    } else if (this.allChildren4AndOver(this.appData)) {
      this.handleAllFourAndOver();
    } else {
      this.handleBothUnderAndOverFour();
    }
  }

    handleAllUnderFour(): void {
        const rules: QualifierRule[] = [
            { index: [true, County.Wayne, undefined], path: 'MatchHeadstartReferral' }
            ,{ index: [true, County.Oakland, undefined], path: 'MatchHeadstartReferral' }
            ,{ index: [true, County.Washtenaw, undefined], path: 'MatchHeadstartReferral' }
            ,{ index: [true, County.Macomb, undefined], path: 'MatchHeadstartReferral' }
            ,{ index: [false, County.Oakland, INCOME_RANGE.FPL_LVL_1_TO_LVL_2], path: 'MatchNoneCDC' }
            ,{ index: [false, County.Washtenaw, INCOME_RANGE.FPL_LVL_1_TO_LVL_2], path: 'MatchNoneCDC' }
            ,{ index: [false, County.Wayne, undefined], path: 'AlternateHSQualifierList2' }
            ,{ index: [false, County.Macomb, undefined], path: 'AlternateHSQualifierList2' }
            ,{ index: [false, County.Oakland, INCOME_RANGE.FPL_LVL_2_TO_LVL_3], path: 'MatchNone' }
            ,{ index: [false, County.Oakland, INCOME_RANGE.FPL_LVL_3_PLUS], path: 'MatchNone' }
            ,{ index: [false, County.Washtenaw, INCOME_RANGE.FPL_LVL_2_TO_LVL_3], path: 'MatchNone' }
            ,{ index: [false, County.Washtenaw, INCOME_RANGE.FPL_LVL_3_PLUS], path: 'MatchNone' }
        ]

        const rule = matchQualifiers(rules, this.oneOrMoreApplies(), this.appData.county, this.appData.fpl)
        if (rule == null) {
            this.$router.push({ path: 'MatchNone' });
            return;
        }
        this.$router.push({ path: rule.path });
    }

    handleAllFourAndOver(): void {
        const allUnder4Rules: QualifierRule[] = [
        { index: [true, County.Wayne, undefined], path: 'PreviouslyAppliedHS' }
        ,{ index: [true, County.Macomb, undefined], path: 'MatchHSGSRPLikelyReferral' }
        ,{ index: [true, County.Washtenaw, undefined], path: 'MatchHSGSRPLikelyReferral' }
        ,{ index: [false, County.Macomb, undefined], path: 'AlternateHSQualifierList2' }
        ,{ index: [false, County.Wayne, undefined], path: 'AlternateHSQualifierList2' }
        ,{ index: [false, County.Washtenaw, undefined], path: 'AlternateGSRPQualifier' }
    ]

    const rule = matchQualifiers(allUnder4Rules, this.oneOrMoreApplies(), this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
        return;
    }
    this.$router.push({ path: rule.path });
  }

  handleBothUnderAndOverFour(): void {
    const rules: QualifierRule[] = [
            { index: [true, undefined, undefined], path: 'PreviouslyAppliedHS' }
            ,{ index: [false, County.Oakland, undefined], path: 'MatchNoneAndGSRPLikelyReferral' }
            ,{ index: [false, County.Washtenaw, undefined ], path: 'AlternateGSRPQualifier' }
            ,{ index: [false, County.Wayne, undefined ], path: 'AlternateHSQualifierList2' }
            ,{ index: [false, County.Macomb, undefined], path: 'AlternateHSQualifierList2' }
        ]

        const rule = matchQualifiers(rules, this.oneOrMoreApplies(), this.appData.county, this.appData.fpl)
        if (rule == null) {
            this.$router.push({ path: 'MatchNone' });
            return;
        }
        this.$router.push({ path: rule.path });
  }

  disableNext(): boolean {
    return !(
      this.fosterChecked ||
      this.homelessChecked ||
      this.benefitsChecked ||
      this.noneChecked
    );
  }
}
